import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useNavigate } from 'react-router-dom';
import { ROUTE_PATHS } from '../../../routes/Routes';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';
import { TaskTemplate } from '../../../types/TaskTemplate';
import { mutationKeys } from '../mutationKeys';

export const postTaskTemplate = async (formData: TaskTemplate) => {
  const response = await CustomAxios.post(`task_templates`, formData);
  const { data } = response;
  return data;
};

type useCreateTaskTemplateProps = {
  onSuccessCallback: () => void;
};

export function useCreateTaskTemplate({ onSuccessCallback }: useCreateTaskTemplateProps) {
  const navigate = useNavigate();
  return useMutation({
    mutationKey: [mutationKeys.createTaskTemplate],
    mutationFn: (formData: TaskTemplate) => postTaskTemplate(formData),
    onSuccess: (data: TaskTemplate) => {
      // fetch again after create
      queryClient.invalidateQueries({ queryKey: [queryKeys.allTaskTemplates, 'new'] });

      // call success
      onSuccessCallback();

      navigate(`/${ROUTE_PATHS.TASK_TEMPLATES}/${data.uuid}`);
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        // let set the query data with bad errored response
        const taskTemplate: TaskTemplate = err.response.data as TaskTemplate;
        queryClient.setQueryData([queryKeys.allTaskTemplates, 'new'], taskTemplate);
      }
    },
  });
}
